import React, {  useRef,useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import IconButton from '@mui/material/IconButton'; 
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem  from "@mui/material/MenuItem";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';  
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import ContractSearchStores from "pages/contracts/editOrNewContract/ContractSearchStores";
import ContractSearchStoresAddresses from "pages/contracts/editOrNewContract/ContractSearchStoresAddress";
import ContractSearchStoresNimaAddresses from "pages/contracts/editOrNewContract/ContractSearchStoresNimaAddress";
import PropTypes from 'prop-types';


const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];

const ContractCreateOrEditOptTras = ({formContract,setFormContract,setIsLoadingErrorData,errorsForm,setErrorsForm,validateFormContract,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect}) => {
    const {t,i18n} = useTranslation(['listDataContracts']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false);  
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);       
    const [priority, setPriority] = useState(1);   
    const [tetxtSearch, setTetxtSearch] = useState("Opt_Tras");   
    const dispatch = useDispatch(); 
    const [postalCodeOptToSelect,setPostalCodeOptToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeOpt, setFilteredpostalCodeOpt] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeOpt, setHighlightedIndexPostalCodeOpt] = useState(-1); // Índice de la opción resaltada 
    const [postalCodeOptFiscalToSelect,setPostalCodeOptFiscalToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeOptFiscal, setfFilteredpostalCodeOptFiscal] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeOptFiscal, setHighlightedIndexPostalCodeOptFiscal] = useState(-1); // Índice de la opción resaltada 
    const [documentIdOptToSelect,setDocumentIdOptToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdOpt, setFilteredDocumentIdOpt] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdOpt, setHighlightedIndexDocumentIdOpt] = useState(-1); // Índice de la opción resaltada 
    const [tradenameOptToSelect,setTradenameOptToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedOpt, setFilteredTradenamedOpt] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedOpt, setHighlightedIndexTradenamedOpt] = useState(-1); // Índice de la opción resaltada 
    const [optNimaToSelect,setOptNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredOptNima, setFilteredOptNima] = useState([]); // Opciones filtradas
    const [highlightedIndexOptNima, setHighlightedIndexOptNima] = useState(-1); // Índice de la opción resaltada 
        
    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
    };
    
    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeOpt([]);
            setHighlightedIndexPostalCodeOpt(-1);
        return;
        }
        const filtered = postalCodeOptToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeOpt(filtered);
        setHighlightedIndexPostalCodeOpt(0);
    }, 300); 
    const handleSelectPostalCodeOpt = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            opt_tras_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            opt_tras_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            opt_tras_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            opt_tras_province_id: postal.province_id || Number(DEFAULTPROVINCE)
        }));
        setFilteredpostalCodeOpt([]);
        setHighlightedIndexPostalCodeOpt(-1);
    }; 
    const handleKeyDownDPostalCodeOpt = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeOpt.length === 0 && formContract.opt_tras_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeOpt(postalCodeOptToSelect);
            setHighlightedIndexPostalCodeOpt(0);
        } else {
            setHighlightedIndexPostalCodeOpt((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeOpt.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexPostalCodeOpt((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeOpt >= 0) {
            if (highlightedIndexPostalCodeOpt >= 0 && highlightedIndexPostalCodeOpt < filteredpostalCodeOpt.length) {
                handleSelectPostalCodeOpt(filteredpostalCodeOpt[highlightedIndexPostalCodeOpt]);
            }
        } else if (event.key === "Escape") {
            const isValid = postalCodeOptToSelect.some((postal) => {
                if (!postal || !postal.postalcode) return false; 
                const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.opt_tras_postalcode_code.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract,
                opt_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                opt_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                opt_tras_province_id: Number(DEFAULTPROVINCE)
            }));
        } 
        setFilteredpostalCodeOpt([]);
        setHighlightedIndexPostalCodeOpt(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchPostalCodeFiscal= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setfFilteredpostalCodeOptFiscal([]);
            setHighlightedIndexPostalCodeOptFiscal(-1);
        return;
        }
        const filtered = postalCodeOptFiscalToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setfFilteredpostalCodeOptFiscal(filtered);
        setHighlightedIndexPostalCodeOptFiscal(0);
    }, 300); 

    const handleSelectPostalCodeOptFiscal = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            opt_tras_postalcode_id_fiscal: postal.id || Number(DEFAULTPOSTALCODE_ID),
            opt_tras_postalcode_code_fiscal: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            opt_tras_postalcode_name_fiscal: postal.name || DEFAULTPOSTALCODE_NAME,
            opt_tras_province_id_fiscal: postal.province_id || Number(DEFAULTPROVINCE)
        }));
        setfFilteredpostalCodeOptFiscal([]);
        setHighlightedIndexPostalCodeOptFiscal(-1);
    };
    const handleKeyDownDPostalCodeOptFiscal = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeOptFiscal.length === 0 && formContract.opt_tras_postalcode_code_fiscal.trim() === "") {
            setHighlightedIndexPostalCodeOptFiscal(postalCodeOptFiscalToSelect);
            setHighlightedIndexPostalCodeOptFiscal(0);
        } else {
            setHighlightedIndexPostalCodeOptFiscal((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeOptFiscal.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexPostalCodeOptFiscal((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeOptFiscal >= 0) {
            if (highlightedIndexPostalCodeOptFiscal >= 0 && highlightedIndexPostalCodeOptFiscal < filteredpostalCodeOptFiscal.length) {
                handleSelectPostalCodeOptFiscal(filteredpostalCodeOptFiscal[highlightedIndexPostalCodeOptFiscal]);
            }
        } else if (event.key === "Escape") {
            const isValid = postalCodeOptFiscalToSelect.some((postal) => {
                if (!postal || !postal.postalcode) return false; 
                const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.opt_tras_postalcode_code_fiscal.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract,
                opt_tras_postalcode_id_fiscal:  Number(DEFAULTPOSTALCODE_ID),
                opt_tras_postalcode_code_fiscal:  DEFAULTPOSTALCODE_CODE,
                opt_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
                opt_tras_province_id_fiscal: Number(DEFAULTPROVINCE)
            }));
        } 
        setfFilteredpostalCodeOptFiscal([]);
        setHighlightedIndexPostalCodeOptFiscal(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchDocumentId = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdOpt([]);
            setHighlightedIndexDocumentIdOpt(-1);
            return;
        }
        const filtered = documentIdOptToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentid = store.documentid.toUpperCase();
            return documentid.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdOpt(filtered);
        setHighlightedIndexDocumentIdOpt(0);
    }, 300);
    const handleSelectDocumentIdOpt = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            opt_tras_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdOpt([]);
        setHighlightedIndexDocumentIdOpt(-1);
    }; 
    const handleKeyDownDocumentIdOpt = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdOpt.length === 0 && formContract.opt_tras_documentid.trim() === "") {
            setFilteredDocumentIdOpt(documentIdOptToSelect);
            setHighlightedIndexDocumentIdOpt(0);
        } else {
            setHighlightedIndexDocumentIdOpt((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdOpt.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexDocumentIdOpt((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdOpt >= 0) {
        if (highlightedIndexDocumentIdOpt >= 0 && highlightedIndexDocumentIdOpt < filteredDocumentIdOpt.length) {
            handleSelectDocumentIdOpt(filteredDocumentIdOpt[highlightedIndexDocumentIdOpt]);
        }
        } else if (event.key === "Escape") {
            const isValid = documentIdOptToSelect.some((store) => {
                if (!store || !store.documentid) return false; 
                const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.opt_tras_documentid.toUpperCase();
                return normalizedStoreId === normalizedInputId;
            }); 
        if (!isValid) {
            setFormContract((formContract) => ({
            ...formContract,
            opt_tras_documentid: "",
            }));
        } 
        setFilteredDocumentIdOpt([]);
        setHighlightedIndexDocumentIdOpt(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchTradename= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedOpt([]);
            setHighlightedIndexTradenamedOpt(-1);
        return;
        }
        const filtered = tradenameOptToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedOpt(filtered);
        setHighlightedIndexTradenamedOpt(0);
    }, 300); 
    const handleSelectTradeNameOpt = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
        ...formContract,
        opt_tras_tradename: store.tradename || "",
        opt_tras_documentid: store.documentid || formContract.opt_tras_documentid,
        
        }));
        setFilteredTradenamedOpt([]);
        setHighlightedIndexTradenamedOpt(-1);
    }; 
    const handleKeyDownTradenameOpt = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedOpt.length === 0 && formContract.opt_tras_tradename.trim() === "") {
            setFilteredTradenamedOpt(tradenameOptToSelect);
            setHighlightedIndexTradenamedOpt(0);
        } else {
            setHighlightedIndexTradenamedOpt((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedOpt.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedOpt((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedOpt >= 0) {
        if (highlightedIndexTradenamedOpt >= 0 && highlightedIndexTradenamedOpt < filteredTradenamedOpt.length) {
            handleSelectTradeNameOpt(filteredTradenamedOpt[highlightedIndexTradenamedOpt]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameOptToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formContract.opt_tras_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormContract((formContract) => ({
            ...formContract,
            opt_tras_tradename: "",
            }));
        } 
        setFilteredTradenamedOpt([]);
        setHighlightedIndexTradenamedOpt(-1);
        }
    }; 

    // Dentro del componente
    const debouncedHandleSearchOptTrasNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredOptNima([]);
            setHighlightedIndexOptNima(-1);
        return;
        }
        const filtered = optNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredOptNima(filtered);
        setHighlightedIndexOptNima(0);
    }, 300); 
    const handleSelectOptTrasNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
        ...formContract,
        opt_tras_nima: nt.nima || ""
        }));
        setFilteredOptNima([]);
        setHighlightedIndexOptNima(-1);
    }; 
    const handleKeyDownOptTrasNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredOptNima.length === 0 && formContract.opt_tras_nima.trim() === "") {
                const filtered = optNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredOptNima(filtered);
                setHighlightedIndexOptNima(0);
            } else {
                setHighlightedIndexOptNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredOptNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexOptNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexOptNima >= 0) {
            if (highlightedIndexOptNima >= 0 && highlightedIndexOptNima < filteredOptNima.length) {
                handleSelectOptTrasNima(filteredOptNima[highlightedIndexOptNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = optNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.opt_tras_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract, 
                opt_tras_nima: ""
            }));
        } 
        setFilteredOptNima([]);
        setHighlightedIndexOptNima(-1);
        }
    };

    // Función para desplazar el contenedor
    const scrollToElement = (index) => {
        const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
        const item = dropdown?.children[index];
        if (item) {
        item.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
        }
    };

    const handleBlur = useCallback((event) => {
            if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeOpt([]);
            setHighlightedIndexPostalCodeOpt(-1);
            setfFilteredpostalCodeOptFiscal([]);
            setHighlightedIndexPostalCodeOptFiscal(-1);
            setFilteredDocumentIdOpt([]);
            setHighlightedIndexDocumentIdOpt(-1);
            setFilteredTradenamedOpt([]);
            setHighlightedIndexTradenamedOpt(-1);  
            setFilteredOptNima([]);
            setHighlightedIndexOptNima(-1);  
        }
    }, []);

    const handleChangeSelectDocumentType_Opt_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            opt_tras_documnettype_id:event.target.value
        }));
    };

    const handleBlurSelectDocumentType_Opt_Tras = (e) => {
        handleChangeSelectDocumentType_Opt_Tras(e);
    };
    
    const handleChangeSelectRoadType_Opt_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            opt_tras_roadtype_id : event.target.value 
        }));
    };

    const handleBlurSelectRoadType_Fiscal_Opt_Tras = (e) => {
        handleChangeSelectRoadTypeFiscal_Opt_Tras(e);
         setErrorsForm(validateFormContract());
    };
    
    const handleChangeSelectRoadTypeFiscal_Opt_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            opt_tras_roadtype_id_fiscal : event.target.value 
        }));
    };

    const handleBlurSelectRoadType_Opt_Tras = (e) => {
        handleChangeSelectRoadType_Opt_Tras(e);
        setErrorsForm(validateFormContract());
    };

    const handleChangeSelectCommunity_Opt_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            opt_tras_community_id : event.target.value   
        }));
    };

    const handleBlurSelectCommunity_Opt_Tras = (e) => {
        handleChangeSelectCommunity_Opt_Tras(e);
        setErrorsForm(validateFormContract());
    };

    const handleChangeSelectCommunityFiscal_Opt_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            opt_tras_community_id_fiscal : event.target.value   
        }));
    };

    const handleBlurSelectCommunityFiscal_Opt_Tras = (e) => {
        handleChangeSelectCommunityFiscal_Opt_Tras(e);
        setErrorsForm(validateFormContract());
    }; 

    const handleChangeDataEditContract_Opt_Tras = (e) => {
        const { name, value } = e.target;
        setFormContract(formContract => ({
          ...formContract,
          [name]: value,
        }));
    };

    const handleBlurDataEditContract_Opt_Tras = (e) => {
        handleChangeDataEditContract_Opt_Tras(e);
        setErrorsForm(validateFormContract());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };
 
    const searchFormStoreAddress = (event) => {
        setPriority(1);
        setTetxtSearch("Opt_Tras");
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreNimaAddress = (event) => {
        setPriority(1);
        setTetxtSearch("Opt_Tras");
        setShowModalSearchStoresNimaAddress(true);
    };
 
    const searchFormStoreAddressFiscal = (event) => {
        setPriority(-1);
        setTetxtSearch("Opt_Tras_Fiscal")
        setShowModalSearchStoresAddress(true);
    };
 
    const deleteDateOptTras = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            opt_tras_store_id:0,
            opt_tras_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
            opt_tras_documentid:"",
            opt_tras_tradename: "",
            opt_tras_name: "",
            opt_tras_contactname: "",
            opt_tras_nima: "",
            opt_tras_inscription: "",
            opt_tras_grnp:"",
            opt_tras_opt: 0,
            opt_tras_phone: "",
            opt_tras_email: "",
            opt_tras_roadtype_id: Number(DEFAULTROADTYE),
            opt_tras_street: "",
            opt_tras_country_id: Number(DEFAULTCOUNTRY),
            opt_tras_country_name:DEFAULTCOUNTRY_NAME,
            opt_tras_province_id: Number(DEFAULTPROVINCE),
            opt_tras_province_name:DEFAULTPROVINCE_NAME,
            opt_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            opt_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            opt_tras_community_id: Number(DEFAULTCOMMUNITY),
            opt_tras_community_name: DEFAULTCOMMUNITY_NAME, 
            opt_tras_roadtype_id_fiscal: Number(DEFAULTROADTYE),
            opt_tras_street_fiscal: "",
            opt_tras_country_id_fiscal: Number(DEFAULTCOUNTRY),
            opt_tras_country_name_fiscal:DEFAULTCOUNTRY_NAME,
            opt_tras_province_id_fiscal: Number(DEFAULTPROVINCE),
            opt_tras_province_name_fiscal:DEFAULTPROVINCE_NAME,
            opt_tras_postalcode_id_fiscal:  Number(DEFAULTPOSTALCODE_ID),
            opt_tras_postalcode_code_fiscal:  DEFAULTPOSTALCODE_CODE,
            opt_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
            opt_tras_community_id_fiscal: Number(DEFAULTCOMMUNITY),
            opt_tras_community_name_fiscal: DEFAULTCOMMUNITY_NAME
        })); 
        setErrorsForm(validateFormContract());
        setErrorsForm(errorsForm => ({
            ...errorsForm,
            opt_tras_store_id:"",
            opt_tras_documnettype_id: "",
            opt_tras_documentid:"",
            opt_tras_tradename: "",
            opt_tras_name: "",
            opt_tras_contactname: "",
            opt_tras_nima: "",
            opt_tras_inscription: "",
            opt_tras_grnp:"",
            opt_tras_opt: 0,
            opt_tras_phone: "",
            opt_tras_email: "",
            opt_tras_roadtype_id: "",
            opt_tras_street: "",
            opt_tras_country_id: "",
            opt_tras_province_id: "",
            opt_tras_postalcode_id: "",
            opt_tras_postalcode_code: "",
            opt_tras_community_id: "",
            opt_tras_roadtype_id_fiscal: "",
            opt_tras_street_fiscal: "",
            opt_tras_country_id_fiscal: "",
            opt_tras_province_id_fiscal: "",
            opt_tras_postalcode_id_fiscal: "",
            opt_tras_postalcode_code_fiscal: "",
            opt_tras_community_id_fiscal: "" 
        }));
        setErrorsForm(errorsForm => ({
            ...errorsForm,
            opt_tras_documentid: 'Text_FieldDateOptTrasDocumentIDRequired'
        })); 
    };

    const deleteDataStreetOptTras = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            opt_tras_roadtype_id: Number(DEFAULTROADTYE),
            opt_tras_street: "",
            opt_tras_country_id: Number(DEFAULTCOUNTRY),
            opt_tras_country_name:DEFAULTCOUNTRY_NAME,
            opt_tras_province_id: Number(DEFAULTPROVINCE),
            opt_tras_province_name:DEFAULTPROVINCE_NAME,
            opt_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            opt_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            opt_tras_community_id: Number(DEFAULTCOMMUNITY),
            opt_tras_community_name: DEFAULTCOMMUNITY_NAME, 
            opt_tras_nima: "",
            opt_tras_inscription: "",
            opt_tras_grnp:"",
            opt_tras_opt: 0
        }));
        setErrorsForm(validateFormContract());
    };

    const deleteDataStreetFiscalOptTras = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            opt_tras_roadtype_id_fiscal: Number(DEFAULTROADTYE),
            opt_tras_country_id_fiscal: Number(DEFAULTCOUNTRY),
            opt_tras_street_fiscal: "",
            opt_tras_country_name_fiscal:DEFAULTCOUNTRY_NAME,
            opt_tras_province_id_fiscal: Number(DEFAULTPROVINCE),
            opt_tras_province_name_fiscal:DEFAULTPROVINCE_NAME,
            opt_tras_postalcode_id_fiscal:  Number(DEFAULTPOSTALCODE_ID),
            opt_tras_postalcode_code_fiscal:  DEFAULTPOSTALCODE_CODE,
            opt_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
            opt_tras_community_id_fiscal: Number(DEFAULTCOMMUNITY),
            opt_tras_community_name_fiscal: DEFAULTCOMMUNITY_NAME
        }));
        setErrorsForm(validateFormContract());
    }; 

    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`contract/getexiststorebynumberdocument/`,token,formContract.opt_tras_documentid.replace(/[.\-/\\|]/g, ""));
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formContract.opt_tras_store_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocument = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getcontractstorebynumberdocument/`,token,formContract.opt_tras_documentid.replace(/[.\-/\\|]/g, ""));
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    if (getData!==undefined && getData!==null && getData!==""){
                        setFormContract(formContract => ({
                            ...formContract,
                            opt_tras_store_id: getData.store_id,
                            opt_tras_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                            opt_tras_tradename: getData.tradename,
                            opt_tras_name: getData.name,
                            opt_tras_contactname: getData.contacname,
                            opt_tras_nima: getData.nima_opt_tras,
                            opt_tras_inscription: getData.pygr_opt_tras,
                            opt_tras_opt: getData.opt_opt_tras,
                            opt_tras_grnp:getData.grnp_opt_tras,
                            opt_tras_phone: getData.phone,
                            opt_tras_email: getData.email, 
                            opt_tras_roadtype_id: (getData.roadtype_id===undefined 
                                                    || getData.roadtype_id===null  
                                                    || getData.roadtype_id===""
                                                    || getData.roadtype_id==="0"
                                                    || getData.roadtype_id===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id,
                            opt_tras_street: getData.street,
                            opt_tras_country_id: (getData.country_id===undefined 
                                                    || getData.country_id===null  
                                                    || getData.country_id===""
                                                    || getData.country_id==="0"
                                                    || getData.country_id===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id,
                            opt_tras_country_name: (getData.country_name===undefined 
                                                    || getData.country_name===null  
                                                    || getData.country_name==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name,
                            opt_tras_province_id: (getData.province_id===undefined 
                                                    || getData.province_id===null  
                                                    || getData.province_id===""
                                                    || getData.province_id==="0"
                                                    || getData.province_id===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id,
                            opt_tras_province_name: (getData.province_name===undefined 
                                                    || getData.province_name===null  
                                                    || getData.province_name==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name, 
                            opt_tras_postalcode_id: (getData.postalcode_id===undefined 
                                                        || getData.postalcode_id===null  
                                                        || getData.postalcode_id===""
                                                        || getData.postalcode_id==="0"
                                                        || getData.postalcode_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                            opt_tras_postalcode_code: (getData.postalcode_code===undefined 
                                                        || getData.postalcode_code===null  
                                                        || getData.postalcode_code==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                            opt_tras_postalcode_name:   (getData.postalcode_name===undefined 
                                                        || getData.postalcode_name===null  
                                                        || getData.postalcode_name==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                            opt_tras_community_id: (getData.community_id===undefined 
                                                        || getData.community_id===null  
                                                        || getData.community_id===""
                                                        || getData.community_id==="0"
                                                        || getData.community_id===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id,
                            opt_tras_community_name:   (getData.community_name===undefined 
                                                        || getData.community_name===null  
                                                        || getData.community_name==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name,  
                            opt_tras_roadtype_id_fiscal: (getData.roadtype_id_fiscal===undefined 
                                                    || getData.roadtype_id_fiscal===null  
                                                    || getData.roadtype_id_fiscal===""
                                                    || getData.roadtype_id_fiscal==="0"
                                                    || getData.roadtype_id_fiscal===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id_fiscal,
                            opt_tras_street_fiscal: getData.street_fiscal,
                            opt_tras_country_id_fiscal: (getData.country_id_fiscal===undefined 
                                                    || getData.country_id_fiscal===null  
                                                    || getData.country_id_fiscal===""
                                                    || getData.country_id_fiscal==="0"
                                                    || getData.country_id_fiscal===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id_fiscal,
                            opt_tras_country_name_fiscal: (getData.country_name_fiscal===undefined 
                                                    || getData.country_name_fiscal===null  
                                                    || getData.country_name_fiscal==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name_fiscal,
                            opt_tras_province_id_fiscal: (getData.province_id_fiscal===undefined 
                                                    || getData.province_id_fiscal===null  
                                                    || getData.province_id_fiscal===""
                                                    || getData.province_id_fiscal==="0"
                                                    || getData.province_id_fiscal===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id_fiscal,
                            opt_tras_province_name_fiscal: (getData.province_name_fiscal===undefined 
                                                    || getData.province_name_fiscal===null  
                                                    || getData.province_name_fiscal==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name_fiscal, 
                            opt_tras_postalcode_id_fiscal: (getData.postalcode_id_fiscal===undefined 
                                                        || getData.postalcode_id_fiscal===null  
                                                        || getData.postalcode_id_fiscal===""
                                                        || getData.postalcode_id_fiscal==="0"
                                                        || getData.postalcodpostalcode_id_fiscal_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id_fiscal,
                            opt_tras_postalcode_code_fiscal: (getData.postalcode_code_fiscal===undefined 
                                                        || getData.postalcode_code_fiscal===null  
                                                        || getData.postalcode_code_fiscal==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code_fiscal,
                            opt_tras_postalcode_name_fiscal:   (getData.postalcode_name_fiscal===undefined 
                                                        || getData.postalcode_name_fiscal===null  
                                                        || getData.postalcode_name_fiscal==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name_fiscal,                       
                            opt_tras_community_id_fiscal: (getData.community_id_fiscal===undefined 
                                                        || getData.community_id_fiscal===null  
                                                        || getData.community_id_fiscal===""
                                                        || getData.community_id_fiscal==="0"
                                                        || getData.community_id_fiscal===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id_fiscal,
                            opt_tras_community_name_fiscal:   (getData.community_name_fiscal===undefined 
                                                        || getData.community_name_fiscal===null  
                                                        || getData.community_name_fiscal==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name_fiscal
                        }));
                        setErrorsForm(validateFormContract());
                    }  
                }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1'){
            if (formContract.opt_tras_documentid && formContract.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,expanded,formContract.opt_tras_documentid,errorsForm.opt_tras_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,setFormContract,formContract.opt_tras_store_id,setErrorsForm,validateFormContract,DEFAULTPROVINCE,
        DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT
    ]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdOpt = async () => {
          try {
            const getData = await helpHttp().get2(ENDPOINT,`contract/getlistdocumentidcontracts/`,token,
              (formContract.opt_tras_documentid!==undefined && formContract.opt_tras_documentid!==null && formContract.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
              setDocumentIdOptToSelect(getData); 
            }
          } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1'){
            if (formContract.opt_tras_documentid && formContract.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdOpt();
            }
        } else{
            setDocumentIdOptToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.opt_tras_documentid,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameOpt = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlisttradenamecontracts/`,token,
                    (formContract.opt_tras_tradename!==undefined && formContract.opt_tras_tradename!==null && formContract.opt_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.opt_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameOptToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1'){
            if (formContract.opt_tras_tradename && formContract.opt_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameOpt();
            }
        } else{
            setTradenameOptToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.opt_tras_tradename,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeOpt = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlistpostalcodect/`,token,
                    (formContract.opt_tras_postalcode_code!==undefined && formContract.opt_tras_postalcode_code!==null && formContract.opt_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.opt_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeOptToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1'){
            if (formContract.opt_tras_postalcode_code && formContract.opt_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeOpt();
            } 
        } else{
            setPostalCodeOptToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.opt_tras_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormContract]);
    
     useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeOptFiscal = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlistpostalcodect/`,token,
                    (formContract.opt_tras_postalcode_code_fiscal!==undefined && formContract.opt_tras_postalcode_code_fiscal!==null && formContract.opt_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.opt_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeOptFiscalToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1'){
            if (formContract.opt_tras_postalcode_code_fiscal && formContract.opt_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeOptFiscal();
            } 
        } else{
            setPostalCodeOptFiscalToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.opt_tras_postalcode_code_fiscal,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormContract]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaOpt = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchct/getlistnimas`,token,formContract.opt_tras_store_id, 
                    (formContract.opt_tras_nima!==undefined && formContract.opt_tras_nima!==null && formContract.opt_tras_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.opt_tras_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setOptNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1'){
            if (formContract.opt_tras_store_id && formContract.opt_tras_store_id!==null && formContract.opt_tras_store_id!=="" && formContract.opt_tras_store_id!=="0" && formContract.opt_tras_store_id!==0){
                fetchDataNimaOpt(); 
            }else{
                setOptNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract,expanded,setFormContract,formContract.opt_tras_store_id]);
    
    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel1') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_DocuentType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="opt_tras_documnettype_id"
                        name="opt_tras_documnettype_id"
                        value={ (formContract.opt_tras_documnettype_id === undefined || formContract.opt_tras_documnettype_id ===null || formContract.opt_tras_documnettype_id ===""
                            || formContract.opt_tras_documnettype_id ==="0" || formContract.opt_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formContract.opt_tras_documnettype_id}
                        inputProps={{ style: {width: 200,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectDocumentType_Opt_Tras}
                        onChange={handleChangeSelectDocumentType_Opt_Tras}
                        helperText={errorsForm.opt_tras_documnettype_id!=null && errorsForm.opt_tras_documnettype_id!==""?t(errorsForm.opt_tras_documnettype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.opt_tras_documnettype_id === undefined || formContract.opt_tras_documnettype_id ===null || formContract.opt_tras_documnettype_id ===""
                                || formContract.opt_tras_documnettype_id ==="0" || formContract.opt_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formContract.opt_tras_documnettype_id
                        }}>
                        <option key={0} value=""/>
                        {documentTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.name}
                            </option>
                        ))}
                    </TextField>  
                    {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    <label className="text-primary" style={{ fontSize: 18}}>{t('Text_CONTRACT_CIF')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="opt_tras_documentid"
                            name="opt_tras_documentid"
                            value={formContract.opt_tras_documentid}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                ...prev,
                                opt_tras_documentid: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchDocumentId(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDocumentIdOpt}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.opt_tras_documentid!=null?t(errorsForm.opt_tras_documentid):t('PlaceHolder_CONTRACT_CIF')}
                            placeholder={t('PlaceHolder_CONTRACT_CIF')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?283:323,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredDocumentIdOpt.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                            borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "400px",
                                overflowY: "auto",
                                width: "250%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredDocumentIdOpt.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectDocumentIdOpt(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexDocumentIdOpt ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDocumentIdOpt ? "white" : "black",
                                    }}
                                >
                                    {store.documentid} - {store.tradename}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>  
                    &nbsp;&nbsp;
                    <IconButton  size="small" className="deletesmall-select-button"   onClick={deleteDateOptTras}>
                        <DeleteIcon style={{fontSize: 28}}/>
                    </IconButton>
                    &nbsp;&nbsp;
                    {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                       <IconButton  size="small" className="edit-select-button" onClick={searchFormStore}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>
                    }
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_TRADENAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="opt_tras_tradename"
                            name="opt_tras_tradename"
                            value={formContract.opt_tras_tradename}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                    ...prev,
                                    opt_tras_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradename(e.target.value);
                            }}
                            onKeyDown={handleKeyDownTradenameOpt}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.opt_tras_tradename!=null && errorsForm.opt_tras_tradename!==""?t(errorsForm.opt_tras_tradename):t('PlaceHolder_CONTRACT_TRADENAME')}
                            placeholder={t('PlaceHolder_CONTRACT_TRADENAME')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?858:834,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredTradenamedOpt.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "800px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedOpt.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameOpt(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedOpt ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedOpt ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                </div>
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_NAME')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <TextField
                    id="opt_tras_name" 
                    name="opt_tras_name"
                    value={formContract.opt_tras_name}
                    inputProps={{ style: {width: i18n.language==='es'?812:857,  fontSize: '18px', }, maxLength: 100 }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                    label={errorsForm.opt_tras_name!=null && errorsForm.opt_tras_name!==""?t(errorsForm.opt_tras_name):t('PlaceHolder_CONTRACT_NAME')}
                    placeholder={t('PlaceHolder_CONTRACT_NAME')}
                    variant="standard"
                    onBlur={handleBlurDataEditContract_Opt_Tras}
                    onChange={handleChangeDataEditContract_Opt_Tras} 
                />
                </div>
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_CONTACT')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <TextField
                    id="opt_tras_contactname" 
                    name="opt_tras_contactname"
                    value={formContract.opt_tras_contactname}
                    inputProps={{ style: {width: i18n.language==='es'?795:840,  fontSize: '18px', }, maxLength: 100 }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                    label={errorsForm.opt_tras_contactname!=null && errorsForm.opt_tras_contactname!==""?t(errorsForm.opt_tras_contactname):t('PlaceHolder_CONTRACT_CONTACT')}
                    placeholder={t('PlaceHolder_CONTRACT_CONTACT')}
                    variant="standard"
                    onBlur={handleBlurDataEditContract_Opt_Tras}
                    onChange={handleChangeDataEditContract_Opt_Tras} 
                />
                </div>
            </div> 
                
            <Typography style={{color:"#067330", fontSize: 16}} >  
                {t('Text_CONTRACT_ADDRESS')}
            </Typography>
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_RoadType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_roadtype"
                        name="opt_tras_roadtype"
                        value={ (formContract.opt_tras_roadtype_id === undefined || formContract.opt_tras_roadtype_id ===null || formContract.opt_tras_roadtype_id ===""
                            || formContract.opt_tras_roadtype_id ==="0" || formContract.opt_tras_roadtype_id ===0)?Number(DEFAULTROADTYE):formContract.opt_tras_roadtype_id}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectRoadType_Opt_Tras}
                        onChange={handleChangeSelectRoadType_Opt_Tras}
                        helperText={errorsForm.opt_tras_roadtype_id!=null && errorsForm.opt_tras_roadtype_id!==""?t(errorsForm.opt_tras_roadtype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.opt_tras_roadtype_id === undefined || formContract.opt_tras_roadtype_id ===null || formContract.opt_tras_roadtype_id ===""
                                || formContract.opt_tras_roadtype_id ==="0" || formContract.opt_tras_roadtype_id ===0)?Number(DEFAULTROADTYE): formContract.opt_tras_roadtype_id
                        }}>
                        <option key={0} value=""/>
                        {roadTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_ADDRESS')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_street" 
                        name="opt_tras_street"
                        value={formContract.opt_tras_street}
                        inputProps={{ style: {width: i18n.language==='es'?449:462,  fontSize: '18px', }, maxLength: 250 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.opt_tras_street!=null && errorsForm.opt_tras_street!==""?t(errorsForm.opt_tras_street):t('PlaceHolder_CONTRACT_ADDRESS')}
                        placeholder={t('PlaceHolder_CONTRACT_ADDRESS')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Opt_Tras}
                        onChange={handleChangeDataEditContract_Opt_Tras}
                    />
                </div>
                &nbsp;&nbsp;
                <IconButton  size="small" className="deletesmall-select-button" onClick={deleteDataStreetOptTras}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton> 
                &nbsp;&nbsp;
                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formContract.opt_tras_documentid!==undefined && formContract.opt_tras_documentid!=="") ?
                    <IconButton  size="small" className={`edit-${
                        (formContract.opt_tras_store_id===undefined
                        || formContract.opt_tras_store_id===""
                        || formContract.opt_tras_store_id==="0"
                        || formContract.opt_tras_store_id===0 )
                        ? "noselect-button": "select-button" }`}
                        disabled={formContract.opt_tras_store_id===undefined
                        || formContract.opt_tras_store_id===""
                        || formContract.opt_tras_store_id==="0"
                        || formContract.opt_tras_store_id===0 }
                                onClick={searchFormStoreAddress}>
                    <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>:
                    <IconButton  size="small" className="edit-noselect-button" disabled>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton> 
                }
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_PostalCode')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="opt_tras_postalcode_code"
                            name="opt_tras_postalcode_code"
                            value={formContract.opt_tras_postalcode_code}
                            onChange={(e) => {
                                    setFormContract(prev => ({
                                    ...prev,
                                    opt_tras_postalcode_code: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchPostalCode(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDPostalCodeOpt}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    const inputPostalCode = formContract.opt_tras_postalcode_code.trim().toUpperCase();
                                    const matchedPostal = postalCodeOptToSelect.find((postal) => {
                                    const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                    return normalizedPostal === inputPostalCode;
                                    });

                                    if (matchedPostal) {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            opt_tras_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                            opt_tras_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                            opt_tras_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                            opt_tras_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE),
                                        }));
                                    } else {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            opt_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                            opt_tras_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                            opt_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                            opt_tras_province_id: Number(DEFAULTPROVINCE),
                                        }));
                                    }
                                    setFilteredpostalCodeOpt([]);
                                    setHighlightedIndexPostalCodeOpt(-1);
                                }
                            }}
                            label={errorsForm.opt_tras_postalcode_code!=null && errorsForm.opt_tras_postalcode_code!==""?t(errorsForm.opt_tras_postalcode_code):t('Text_CONTRACT_PostalCode')}
                            placeholder={t('Text_CONTRACT_PostalCode')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredpostalCodeOpt.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                width: "350%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredpostalCodeOpt.map((postal, index) => (
                                <MenuItem
                                    key={postal.id}
                                    onClick={() => handleSelectPostalCodeOpt(postal)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexPostalCodeOpt ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexPostalCodeOpt ? "white" : "black",
                                    }}
                                >
                                    {postal.postalcode} - {postal.name}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Locality')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_postalcode_name" 
                        name="opt_tras_postalcode_name"
                        value={formContract.opt_tras_postalcode_name}
                        inputProps={{ style: {width: i18n.language==='es'?210:241,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.opt_tras_postalcode_name!=null && errorsForm.opt_tras_postalcode_name!==""?t(errorsForm.opt_tras_contactname):t('Text_CONTRACT_Locality')}
                        placeholder={t('Text_CONTRACT_Locality')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Opt_Tras}
                        onChange={handleChangeDataEditContract_Opt_Tras}
                        disabled
                    />  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Community')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_community_id"
                        name="opt_tras_community_id"
                        value={ (formContract.opt_tras_community_id === undefined || formContract.opt_tras_community_id ===null || formContract.opt_tras_community_id ===""
                            || formContract.opt_tras_community_id ==="0" || formContract.opt_tras_community_id ===0)?Number(DEFAULTCOMMUNITY):formContract.opt_tras_community_id}
                        inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectCommunity_Opt_Tras}
                        onChange={handleChangeSelectCommunity_Opt_Tras}
                        helperText={errorsForm.opt_tras_community_id!=null  && errorsForm.opt_tras_community_id!==""?t(errorsForm.opt_tras_community_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.opt_tras_community_id === undefined || formContract.opt_tras_community_id ===null || formContract.opt_tras_community_id ===""
                                || formContract.opt_tras_community_id ==="0" || formContract.opt_tras_community_id ===0)?Number(DEFAULTCOMMUNITY): formContract.opt_tras_community_id
                        }}>
                        {communityToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>
                </div>
            </div> 
            
            <Typography style={{color:"#067330", fontSize: 16}} >  
                {t('Text_CONTRACT_ADDRESS_FISCAL')}
            </Typography>
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_RoadType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_roadtype_id_fiscal"
                        name="opt_tras_roadtype_id_fiscal"
                        value={ (formContract.opt_tras_roadtype_id_fiscal === undefined || formContract.opt_tras_roadtype_id_fiscal ===null || formContract.opt_tras_roadtype_id_fiscal ===""
                            || formContract.opt_tras_roadtype_id_fiscal ==="0" || formContract.opt_tras_roadtype_id_fiscal ===0)?Number(DEFAULTROADTYE):formContract.opt_tras_roadtype_id_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectRoadType_Fiscal_Opt_Tras}
                        onChange={handleChangeSelectRoadTypeFiscal_Opt_Tras}
                        helperText={errorsForm.opt_tras_roadtype_id_fiscal!=null && errorsForm.opt_tras_roadtype_id_fiscal!==""?t(errorsForm.opt_tras_roadtype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.opt_tras_roadtype_id_fiscal === undefined || formContract.opt_tras_roadtype_id_fiscal ===null || formContract.opt_tras_roadtype_id_fiscal ===""
                                || formContract.opt_tras_roadtype_id_fiscal ==="0" || formContract.opt_tras_roadtype_id_fiscal ===0)?Number(DEFAULTROADTYE): formContract.opt_tras_roadtype_id_fiscal
                        }}>
                        <option key={0} value=""/>
                        {roadTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_ADDRESS')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_street_fiscal" 
                        name="opt_tras_street_fiscal"
                        value={formContract.opt_tras_street_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?449:462,  fontSize: '18px', }, maxLength: 250 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.opt_tras_street_fiscal!=null && errorsForm.opt_tras_street_fiscal!==""?t(errorsForm.opt_tras_street_fiscal):t('PlaceHolder_CONTRACT_ADDRESS')}
                        placeholder={t('PlaceHolder_CONTRACT_ADDRESS')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Opt_Tras}
                        onChange={handleChangeDataEditContract_Opt_Tras}
                    />
                </div>
                &nbsp;&nbsp;
                <IconButton  size="small" className="deletesmall-select-button" onClick={deleteDataStreetFiscalOptTras}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton>
                &nbsp;&nbsp;
                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formContract.opt_tras_documentid!==undefined && formContract.opt_tras_documentid!=="") ?
                    <IconButton  size="small" className={`edit-${
                        (formContract.opt_tras_store_id===undefined
                        || formContract.opt_tras_store_id===""
                        || formContract.opt_tras_store_id==="0"
                        || formContract.opt_tras_store_id===0 )
                        ? "noselect-button": "select-button" }`}
                        disabled={formContract.opt_tras_store_id===undefined
                        || formContract.opt_tras_store_id===""
                        || formContract.opt_tras_store_id==="0"
                        || formContract.opt_tras_store_id===0 }
                                onClick={searchFormStoreAddressFiscal}>
                    <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>:
                    <IconButton  size="small" className="edit-noselect-button" disabled>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>
                }
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_PostalCode')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="opt_tras_postalcode_code_fiscal"
                            name="opt_tras_postalcode_code_fiscal"
                            value={formContract.opt_tras_postalcode_code_fiscal}
                            onChange={(e) => {
                                    setFormContract(prev => ({
                                    ...prev,
                                    opt_tras_postalcode_code_fiscal: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchPostalCodeFiscal(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDPostalCodeOptFiscal}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    const inputPostalCode = formContract.opt_tras_postalcode_code_fiscal.trim().toUpperCase();
                                    const matchedPostal = postalCodeOptFiscalToSelect.find((postal) => {
                                    const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                    return normalizedPostal === inputPostalCode;
                                    });

                                    if (matchedPostal) {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            opt_tras_postalcode_id_fiscal: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                            opt_tras_postalcode_code_fiscal: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                            opt_tras_postalcode_name_fiscal: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                            opt_tras_province_id_fiscal: matchedPostal.province_id || Number(DEFAULTPROVINCE),
                                        }));
                                    } else {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            opt_tras_postalcode_id_fiscal: Number(DEFAULTPOSTALCODE_ID),
                                            opt_tras_postalcode_code_fiscal: DEFAULTPOSTALCODE_CODE,
                                            opt_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
                                            opt_tras_province_id_fiscal: Number(DEFAULTPROVINCE),
                                        }));
                                    }
                                    setfFilteredpostalCodeOptFiscal([]);
                                    setHighlightedIndexPostalCodeOptFiscal(-1);
                                }
                            }}
                            label={errorsForm.opt_tras_postalcode_code_fiscal!=null && errorsForm.opt_tras_postalcode_code_fiscal!==""?t(errorsForm.opt_tras_postalcode_code_fiscal):t('Text_CONTRACT_PostalCode')}
                            placeholder={t('Text_CONTRACT_PostalCode')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredpostalCodeOptFiscal.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                width: "350%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredpostalCodeOptFiscal.map((postal, index) => (
                                <MenuItem
                                    key={postal.id}
                                    onClick={() => handleSelectPostalCodeOptFiscal(postal)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexPostalCodeOptFiscal ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexPostalCodeOptFiscal ? "white" : "black",
                                    }}
                                >
                                    {postal.postalcode} - {postal.name}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Locality')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_postalcode_name_fiscal" 
                        name="opt_tras_postalcode_name_fiscal"
                        value={formContract.opt_tras_postalcode_name_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?210:241,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.opt_tras_postalcode_name_fiscal!=null && errorsForm.opt_tras_postalcode_name_fiscal!==""?t(errorsForm.opt_tras_postalcode_name_fiscal):t('Text_CONTRACT_Locality')}
                        placeholder={t('Text_CONTRACT_Locality')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Opt_Tras}
                        onChange={handleChangeDataEditContract_Opt_Tras}
                        disabled
                    />  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Community')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_community_id_fiscal"
                        name="opt_tras_community_id_fiscal"
                        value={ (formContract.opt_tras_community_id_fiscal === undefined || formContract.opt_tras_community_id_fiscal ===null || formContract.opt_tras_community_id_fiscal ===""
                            || formContract.opt_tras_community_id_fiscal ==="0" || formContract.opt_tras_community_id_fiscal ===0)?Number(DEFAULTCOMMUNITY):formContract.opt_tras_community_id_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectCommunityFiscal_Opt_Tras}
                        onChange={handleChangeSelectCommunityFiscal_Opt_Tras}
                        helperText={errorsForm.opt_tras_community_id_fiscal!=null  && errorsForm.opt_tras_community_id_fiscal!==""?t(errorsForm.opt_tras_community_id_fiscal):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.opt_tras_community_id_fiscal === undefined || formContract.opt_tras_community_id_fiscal ===null || formContract.opt_tras_community_id_fiscal ===""
                                || formContract.opt_tras_community_id_fiscal ==="0" || formContract.opt_tras_community_id_fiscal ===0)?Number(DEFAULTCOMMUNITY): formContract.opt_tras_community_id_fiscal
                        }}>
                        {communityToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>
                </div>
            </div>
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Phone')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="opt_tras_phone" 
                        name="opt_tras_phone"
                        value={formContract.opt_tras_phone}
                        inputProps={{ style: {width: 180,  fontSize: '18px', }, maxLength: 30 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}    
                        label={errorsForm.opt_tras_phone!=null && errorsForm.opt_tras_phone!==""?t(errorsForm.opt_tras_phone):t('PlaceHolder_CONTRACT_Phone')}
                        placeholder={t('PlaceHolder_CONTRACT_Phone')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Opt_Tras}
                        onChange={handleChangeDataEditContract_Opt_Tras}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Email')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="opt_tras_email" 
                        name="opt_tras_email"
                        value={formContract.opt_tras_email}
                        inputProps={{ style: {width: i18n.language==='es'?319:335 ,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                        label={errorsForm.opt_tras_email!=null && errorsForm.opt_tras_email!==""?t(errorsForm.opt_tras_email):t('PlaceHolder_CONTRACT_Email')}
                        placeholder={t('PlaceHolder_CONTRACT_Email')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Opt_Tras}
                        onChange={handleChangeDataEditContract_Opt_Tras}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_NIMA')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="opt_tras_nima"
                            name="opt_tras_nima"
                            value={formContract.opt_tras_nima}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                ...prev,
                                opt_tras_nima: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchOptTrasNima(e.target.value);
                            }}
                            onKeyDown={handleKeyDownOptTrasNima}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.opt_tras_nima!=null && errorsForm.opt_tras_nima!==""?t(errorsForm.opt_tras_nima):t('PlaceHolder_CONTRACT_NIMA')}
                            placeholder={t('PlaceHolder_CONTRACT_NIMA')}
                            variant="standard"
                            inputProps={{ style: {width: 133,  fontSize: '18px'}, maxLength: 50 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredOptNima.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "140%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredOptNima.map((nt, index) => (
                                <MenuItem
                                    key={nt.id}
                                    onClick={() => handleSelectOptTrasNima(nt)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexOptNima ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexOptNima ? "white" : "black",
                                    }}
                                >
                                    {nt.nima}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;
                    {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formContract.opt_tras_documentid!==undefined && formContract.opt_tras_documentid!=="") ?
                        <IconButton  size="small" className={`edit-${
                            (formContract.opt_tras_store_id===undefined
                            || formContract.opt_tras_store_id===""
                            || formContract.opt_tras_store_id==="0"
                            || formContract.opt_tras_store_id===0
                            )? "noselect-button": "select-button" }`}
                            disabled={formContract.opt_tras_store_id===undefined
                            || formContract.opt_tras_store_id===""
                            || formContract.opt_tras_store_id==="0"
                            || formContract.opt_tras_store_id===0} 
                            onClick={searchFormStoreNimaAddress}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>:
                        <IconButton  size="small" className="edit-noselect-button" disabled>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>  
                    }
                </div>
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_INSCRIPTION')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="opt_tras_inscription" 
                        name="opt_tras_inscription"
                        value={formContract.opt_tras_inscription}
                        inputProps={{ style: {width:350,  fontSize: '18px'}, maxLength: 50 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}      
                        label={errorsForm.opt_tras_inscription!=null && errorsForm.opt_tras_inscription!==""?t(errorsForm.opt_tras_inscription):t('PlaceHolder_CONTRACT_INSCRIPTION')}
                        placeholder={t('PlaceHolder_CONTRACT_INSCRIPTION')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Opt_Tras}
                        onChange={handleChangeDataEditContract_Opt_Tras} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_OPT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <TextField
                        id="opt_tras_opt"
                        name="opt_tras_opt"
                        value={ (formContract.opt_tras_opt === undefined || formContract.opt_tras_opt ===null || formContract.opt_tras_opt ===""
                            || formContract.opt_tras_opt ==="0" || formContract.opt_tras_opt ===0)?0:formContract.opt_tras_opt}
                        inputProps={{ style: {width: i18n.language==='es'?194:171,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                        variant="outlined"
                        onBlur={handleBlurDataEditContract_Opt_Tras}
                        onChange={handleChangeDataEditContract_Opt_Tras} 
                        helperText={errorsForm.opt_tras_opt!=null?t(errorsForm.opt_tras_opt):""}
                            select
                        SelectProps={{
                            native: true,
                            value: (formContract.opt_tras_opt === undefined || formContract.opt_tras_opt ===null || formContract.opt_tras_opt ===""
                                || formContract.opt_tras_opt ==="0" || formContract.opt_tras_opt ===0)?0: formContract.opt_tras_opt
                        }}>
                        <option key={0} value=""/>
                        {optTypeToSelect.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.code} - {option.namees.substring(0,20)}
                        </option>
                        ))}
                    </TextField>            
                </div>
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_GESTOR')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="opt_tras_grnp" 
                        name="opt_tras_grnp"
                        value={formContract.opt_tras_grnp}
                        inputProps={{ style: {width: i18n.language==='es'?684:250, fontSize: '18px'}, maxLength: 50 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.opt_tras_grnp!=null && errorsForm.opt_tras_grnp!==""?t(errorsForm.opt_tras_grnp):t('PlaceHolder_CONTRACT_GESTOR')}
                        placeholder={t('PlaceHolder_CONTRACT_GESTOR')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Opt_Tras}
                        onChange={handleChangeDataEditContract_Opt_Tras} 
                    />
                    
                </div>
            </div> 
        
            <ContractSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Opt_Tras"}
                setFormContract={setFormContract}
            />
            <ContractSearchStoresAddresses
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                selectStores={tetxtSearch}
                setFormContract={setFormContract}
                titleTable={formContract.opt_tras_tradename}
                store_id={formContract.opt_tras_store_id}
                priority={priority}
            />
             <ContractSearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={tetxtSearch}
                setFormContract={setFormContract}
                titleTable={formContract.opt_tras_tradename}
                store_id={formContract.opt_tras_store_id} 
            />
        </> 
    )
}

ContractCreateOrEditOptTras.propTypes = {
    formContract: PropTypes.object.isRequired,
    setFormContract: PropTypes.func.isRequired,
    setIsLoadingErrorData: PropTypes.func.isRequired,
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateFormContract: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired,
    optTypeToSelect: PropTypes.array.isRequired
  };
  
  export default ContractCreateOrEditOptTras;